import { RefObject, useLayoutEffect, useState } from 'react';

export const useOverflowing = (ref: RefObject<HTMLDivElement | null>) => {
	const [isOverflow, setIsOverflow] = useState(false);

	useLayoutEffect(() => {
		const { current } = ref;

		const trigger = () => {
			const scrollHeight = current?.scrollHeight ?? 0;
			const clientHeight = current?.clientHeight ?? 0;
			const hasOverflow = scrollHeight > clientHeight;

			setIsOverflow(hasOverflow);
		};

		if (current) {
			if ('ResizeObserver' in window) {
				new ResizeObserver(trigger).observe(current);
			}

			trigger();
		}
	}, [ref]);

	return isOverflow;
};
